import { createElement } from 'react';
export const compose = (...functions) => (x, config) => functions.reduceRight((acc, fn) => createElement(fn, config, acc), x);
export const createWidgetWrapperElement = (WidgetComp, props) => createElement(WidgetComp, props);
/**
 * @TODO: move this to common.
 * @description: Generates a hash string to be used as instance id for a widget.
 * @return: string
 */
export const generateId = () => Math.random().toString(36).substring(2, 9);
